const TOKEN_KEY = 'access_token'
const USER_ID_KEY = 'userId'
const USERNAME = 'userName'
const VACANCY = 'vacancy'
const ISAGREE = "isAgree"
const QUESTIONS = "questions"
const EXPIRE = "expire"
const DEP_CURRENCY_ID = "depCurrencyId"
const SELECT_VACANCY_ID = "selectedVacancyId"
const SELECT_VACANCY_Staff = "selectedVacancyStaff"
const TokenService = {

    setselectedVacancyStaff(data) {
        localStorage.setItem( SELECT_VACANCY_Staff, JSON.stringify( data ) );
    },
    getselectedVacancyStaff() {
        return JSON.parse( localStorage.getItem( SELECT_VACANCY_Staff ) );
    },
    setselectedVacancy(data) {
        localStorage.setItem( SELECT_VACANCY_ID, JSON.stringify( data ) );
    },
    getselectedVacancy() {
        return JSON.parse( localStorage.getItem( SELECT_VACANCY_ID ) );
    },
    setTest(data) {
        localStorage.setItem( QUESTIONS, JSON.stringify( data ) );
    },
    getTest() {
        return JSON.parse( localStorage.getItem( QUESTIONS ) );
    },
    saveExpire(data) {
        localStorage.setItem( EXPIRE, data )
    },
    getExpire() {
        return JSON.parse( localStorage.getItem( EXPIRE ) );
    },
    removeExpire() {
        localStorage.removeItem( EXPIRE );
    },
    removeTest() {
        localStorage.removeItem( QUESTIONS );
    },
    setTestAgreement(data) {
        localStorage.setItem( ISAGREE, data );
    },
    getAgreement() {
        return JSON.parse( localStorage.getItem( ISAGREE ) );
    },

    //
    getToken() {
        return localStorage.getItem( TOKEN_KEY );
    },
    saveToken(token) {
        localStorage.setItem( TOKEN_KEY, token );
    },
    saveCurrentUserId(id) {
        localStorage.setItem( USER_ID_KEY, id );
    },
    getCurrentUserId() {
        return localStorage.getItem( USER_ID_KEY );
    },
    removeToken() {
        localStorage.removeItem( TOKEN_KEY );
    },
    removeCurrentUserId() {
        localStorage.removeItem( USER_ID_KEY );
    },

    removeUserName() {
        return localStorage.removeItem( USERNAME );
    },
    DEP_CURRENCY_ID() {
        return localStorage.removeItem( DEP_CURRENCY_ID );
    },

    setUserName(userName) {
        localStorage.setItem( USERNAME, userName );
    },
    getUserName() {
        return localStorage.getItem( USERNAME );
    },

};

export {TokenService}
